import { loadable } from '../../../common/utils/lazyLoading';
const MyLearningSpaceStaff = loadable(() => import('../MyLearningSpaceStaff'));
const MyLearningSpaceStudent = loadable(() => import('../MyLearningSpaceStudent'));
const News = loadable(() => import('../News'));
export default ({ isStaff, isStudent }) => {
    const pages = [
        {
            id: 'news',
            title: 'News',
            route: 'news',
            component: News,
            icon: 'newspaper',
            permission: 'news',
        },
    ];
    if (isStaff) {
        pages.push({
            id: 'my_learning_space_staff',
            title: 'My Learning Space (Staff)',
            route: 'staff',
            component: MyLearningSpaceStaff,
            icon: 'bell2',
            permission: 'my_learning_space_staff',
        });
    }
    if (isStudent) {
        pages.push({
            id: 'my_learning_space_student',
            title: 'My Learning Space (Student)',
            route: 'student',
            component: MyLearningSpaceStudent,
            icon: 'bell2',
            permission: 'my_learning_space_student',
        });
    }
    return pages;
};
